import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'input-p',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    imports: [FormsModule, TranslatePipe]
})
export class InputPComponent implements OnInit {


 	@Input() inputField: any;

	typeMode: string = "none";

	click?: string;

	constructor() { }

	ngOnInit() {
	}

	disableGboard() {
		this.typeMode = "none";
		console.log("G-BOARD: DISABLE");
	}

	enableGboard() {
		this.typeMode = "numeric";
		console.log("G-BOARD: ENABLE");
		this.click = "Duplo clique"
	}
}

